<div class="row justify-content-center" [ngClass]="routeAnimationsElements">
  <div class="col-md-8">
    <mat-card>
      <div *ngFor="let empresa of listaEmpresas">
        <div style="margin-bottom:5px;">
          <button [ngClass]="routeAnimationsElements" mat-raised-button style="width: 100%;" class="actions-main"
            color="primary" (click)="onSelectEmpresa(empresa)" [disabled]="disableButton(empresa.idEntidadProductiva)">
            {{empresa.nombrePersonaFoJ}}
          </button>
        </div>
      </div>

      <div class="row buttons d-flex justify-content-between pad" [ngClass]="routeAnimationsElements">
        <button type="submit" mat-raised-button routerLink="/empresas/registro-empresa" color="primary">
          Registrar Empresa
        </button>
      </div>
    </mat-card>
  </div>
</div>